import React, { Component, useState } from "react";
import "leaflet/dist/leaflet.css";
import Navbar from "../Navbar";
import { Link } from "react-router-dom";

const GlobalFeedProduction = () => {
  return (
    <>
      <div className="geomap-powerbi">
        <iframe
          title="Global Market"
          width="1140"
          height="541.25"
          src="https://app.powerbi.com/reportEmbed?reportId=7a43e372-8f06-45a8-931b-7d99f6d1eff0&autoAuth=true&ctid=8c308e15-1480-4168-aed7-b0f7a1352095"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </div>
      <div className="map-insight">
        <div className="global-market-title">
          ปริมาณความต้องการอาหารสัตว์โลก ปี 2021
        </div>
        <div className="global-market-desc-grid">
          <div className="global-market-desc-box">
            <div className="global-market-desc-title">รวมทั่วโลก</div>
            <div className="global-market-desc-box-grid-left">
              <div>ผลิต</div>
              <div className="global-market-desc-number">1,236</div>
              <div>ล้านตัน</div>
            </div>
          </div>
          <div className="global-market-desc-box">
            <div className="global-market-desc-title">CP Group</div>
            <div className="global-market-desc-box-grid-right">
              <div>อันดับ</div>
              <div className="global-market-desc-number">1</div>
              <div>ผลิต</div>
              <div className="global-market-desc-number">34</div>
              <div>ล้านตัน</div>
              <div>ส่วนแบ่งการตลาด</div>
              <div className="global-market-desc-number">3%</div>
            </div>
          </div>
        </div>
        <table className="global-feed-production-table">
          <tr>
            <th>No.</th>
            <th>Name</th>
            <th>Country</th>
            <th>Volume (Million Tons/Yr.)</th>
            <th>Share (%)</th>
          </tr>
          <tr>
            <td>2</td>
            <td>New Hope Group</td>
            <td>China</td>
            <td>28</td>
            <td>2%</td>
          </tr>
          <tr>
            <td>3</td>
            <td>Haid Group</td>
            <td>China</td>
            <td>20</td>
            <td>2%</td>
          </tr>
          <tr>
            <td>4</td>
            <td>Cargill</td>
            <td>USA</td>
            <td>20</td>
            <td>2%</td>
          </tr>
          <tr>
            <td>5</td>
            <td>Land O’Lake</td>
            <td>USA</td>
            <td>14</td>
            <td>1%</td>
          </tr>
          <tr>
            <td>6</td>
            <td>Others</td>
            <td></td>
            <td>1,120</td>
            <td>90%</td>
          </tr>
        </table>
      </div>
    </>
  );
};

export default GlobalFeedProduction;
